const ShimmerLoader = ({ className }) => {
  return (
    <div className={className}>
      <div
        className={`relative overflow-hidden w-full h-full bg-rule`}
      >
        <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-shade-50" />
      </div>
    </div>
  );
};

export default ShimmerLoader;